import {Component, ElementRef, HostListener, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BackendService} from "@app/core/backendService/backend.service";
import {
  RewardRedeemConfirmationData
} from "@app/feature/reward/reward-redeem-confirmation/reward-redeem-confirmation.component";
import {RewardService} from "@app/feature/reward/service/reward.service";


@Component({
  selector: 'app-reward-redeem-confirmation-dialog',
  templateUrl: './reward-redeem-confirmation-dialog.component.html',
  styleUrls: ['./reward-redeem-confirmation-dialog.component.scss']
})
export class RewardRedeemConfirmationDialogComponent{

  constructor(
    public backendService: BackendService,
    private rewardService: RewardService,
    public dialogRef: MatDialogRef<RewardRedeemConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RewardRedeemConfirmationData,
  )
  {}
  confirm(){ this.dialogRef.close(this.data) }
}


